import { useState } from "react";
import QRCode from "react-qr-code";
import { toast } from "sonner";
import { Copy, Check, Download } from "lucide-react";
import { tippingBase } from "@/lib/domains";

// Shows the scannable QR + shareable pay link for a card code.
// The QR encodes {tippingBase}/pay/{code}, which resolves to the linked worker's payment page.
export function PayQrCard({ code, workerName, className = "" }) {
  const [copied, setCopied] = useState(false);
  const payUrl = `${tippingBase()}/pay/${code}`;

  const copy = async () => {
    await navigator.clipboard.writeText(payUrl);
    setCopied(true);
    toast.success("Pay link copied");
    setTimeout(() => setCopied(false), 1500);
  };

  const download = () => {
    const svg = document.getElementById(`qr-${code}`);
    if (!svg) return;
    const data = new XMLSerializer().serializeToString(svg);
    const img = new Image();
    const canvas = document.createElement("canvas");
    const size = 512;
    canvas.width = size; canvas.height = size;
    img.onload = () => {
      const ctx = canvas.getContext("2d");
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, size, size);
      ctx.drawImage(img, 32, 32, size - 64, size - 64);
      const a = document.createElement("a");
      a.download = `tiplyme-${code}.png`;
      a.href = canvas.toDataURL("image/png");
      a.click();
    };
    img.src = "data:image/svg+xml;base64," + btoa(data);
  };

  return (
    <div className={`rounded-xl border border-border/60 bg-white p-4 text-center ${className}`} data-testid={`pay-qr-${code}`}>
      <div className="mx-auto w-fit rounded-lg bg-white p-2">
        <QRCode id={`qr-${code}`} value={payUrl} size={160} fgColor="#101F38" bgColor="#ffffff" />
      </div>
      <p className="mt-3 font-mono text-sm font-bold text-brand-navy" data-testid={`pay-qr-code-${code}`}>{code}</p>
      {workerName && <p className="text-xs text-muted-foreground">Pays <span className="font-semibold text-foreground">{workerName}</span></p>}
      <div className="mt-3 flex items-center gap-1.5 rounded-lg bg-secondary/60 px-2.5 py-2">
        <span className="flex-1 truncate text-left text-xs text-muted-foreground" data-testid={`pay-qr-link-${code}`}>{payUrl}</span>
        <button type="button" onClick={copy} className="rounded-md border border-border bg-white p-1.5 hover:bg-secondary" data-testid={`pay-qr-copy-${code}`} title="Copy link">
          {copied ? <Check className="h-3.5 w-3.5 text-brand-cyan" /> : <Copy className="h-3.5 w-3.5" />}
        </button>
        <button type="button" onClick={download} className="rounded-md border border-border bg-white p-1.5 hover:bg-secondary" data-testid={`pay-qr-download-${code}`} title="Download QR">
          <Download className="h-3.5 w-3.5" />
        </button>
      </div>
    </div>
  );
}
